module.exports = __webpack_public_path__ + "static/rulers-db20f15946c6c627fc34f5522dbfff2b.png";